import { fetchRestrictions } from '@/services/countries';
import { useEffect, useState } from 'react';

let cachedBlockedSet: Set<string> | null = null;

export function useRestrictions() {
    const [blockedSet, setBlockedSet] = useState<Set<string>>(cachedBlockedSet || new Set());
    const [loading, setLoading] = useState(!cachedBlockedSet);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (cachedBlockedSet) {
            return;
        }

        async function loadRestrictions() {
            try {
                const countries = await fetchRestrictions();
                const set = new Set(countries);
                cachedBlockedSet = set;
                setBlockedSet(set);
            } catch (err) {
                console.error('Error fetching restrictions:', err);
                setError('Failed to fetch country restrictions');
            } finally {
                setLoading(false);
            }
        }

        loadRestrictions();
    }, []);

    return { blockedSet, loading, error };
}
